module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fixed-header', {
    staticClass: "u-header",
    attrs: {
      "id": "js-header",
      "fixed": _vm.isFixed,
      "threshold": 50
    },
    on: {
      "update:fixed": function($event) {
        _vm.isFixed = $event
      }
    }
  }, [_c('div', {
    staticClass: "u-header__section temp-header",
    class: {
      header: _vm.isFixed
    }
  }, [_c('div', {
    staticClass: "g-bg-main main-header",
    class: {
      'is-collapse': _vm.isCollapse
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    staticClass: "evf_logo",
    class: {
      evf_logo_height: !_vm.isLogIn
    },
    attrs: {
      "src": "/static/assets/img/logo/OSEL Foundation_white_horizontal.png"
    }
  })]), _vm._v(" "), (!_vm.isLogIn && _vm.referralLogo) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.referralLogo,
      "alt": "Referral Logo"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountType == 'master') ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [(_vm.isLogIn) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.cltl_logo_white
    }
  }) : _vm._e()]) : (_vm.sponsors != null) ? _c('span', [(_vm.sponsors.hyperLinkMajor != '') ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.sponsors.hyperLinkMajor
    }
  }, [(_vm.isLogIn && _vm.sponsors.majorLogo) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.sponsors.majorLogo
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sponsors.hyperLinkMajor == '') ? _c('a', {
    attrs: {
      "target": "_blank"
    }
  }, [(_vm.isLogIn && _vm.sponsors.majorLogo) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.sponsors.majorLogo
    }
  }) : _vm._e()]) : _vm._e()]) : _c('span', [_c('a', [(_vm.isLogIn && _vm.sponsors.majorLogo) ? _c('img', {
    staticClass: "major-sponsor-sm",
    attrs: {
      "src": _vm.sponsors.majorLogo
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "hamburger-div",
    on: {
      "click": function($event) {
        _vm.isCollapse = !_vm.isCollapse
      }
    }
  }), _vm._v(" "), (_vm.isLogIn) ? _c('div', {
    staticClass: "collapse-button"
  }, [_c('span', {
    staticClass: "g-color-white",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isCollapse) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "nav-collapse"
  }, [(_vm.isLogIn) ? _c('ul', {
    staticClass: "navigation-bar-collapse"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Home')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_vm._v("Order")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_vm._v("Track Order")])]), _vm._v(" "), (
    this.framePageVisible == 'true' ||
    _vm.MasterAccountType == 'master'
  ) ? _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('FramesCenter')
      }
    }
  }, [_vm._v("Frames")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resource')
      }
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('UserAccount')
      }
    }
  }, [_vm._v("My Account")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_vm._v("Help")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15",
    on: {
      "click": function($event) {
        return _vm.LogOut()
      }
    }
  }, [_vm._v("Log Out")])])])]) : _vm._e(), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container g-py-15 nav-container"
  }, [(_vm.isLogIn) ? _c('ul', {
    staticClass: "navigation-bar"
  }, [_c('div', [_c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'home'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Home')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'order'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_vm._v("Order")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'track-order'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_vm._v("Track Order")])]), _vm._v(" "), (
    this.framePageVisible == 'true' ||
    _vm.MasterAccountType == 'master'
  ) ? _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'frame'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('FramesCenter')
      }
    }
  }, [_vm._v("Frames")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'resource'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resource')
      }
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'my-account'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('UserAccount')
      }
    }
  }, [_vm._v("My Account")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    class: {
      isActive: _vm.isActive == 'help'
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_vm._v("Help")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item list-inline-item d-none d-lg-inline-block"
  }, [_c('a', {
    staticClass: "u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18",
    on: {
      "click": function($event) {
        return _vm.LogOut()
      }
    }
  }, [_vm._v("Log Out")])])])]) : _vm._e()])], 1), _vm._v(" "), (
    _vm.AccountStatus == 'OrderHoldUnderReview' &&
    _vm.showTheNotificationAlert == 'false' &&
    _vm.activeCurrentPage == 'order'
  ) ? _c('div', {
    staticClass: "g-bg-main g-py-10"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "alert alert-danger alert-dismissible fade show",
    attrs: {
      "id": "successDiv",
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("This account is unable to place orders at this time.")])])])]) : _vm._e(), _vm._v(" "), (_vm.showTheNotificationAlert == 'true') ? _c('div', {
    staticClass: "g-py-10"
  }, [_c('div', {
    staticClass: "col-lg-10 offset-lg-1"
  }, [(_vm.notificationMessage != 'null') ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible fade show",
    attrs: {
      "id": "successDiv",
      "role": "alert"
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert",
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.hideNotificationAlert()
      }
    }
  }, [_vm._v("×")]), _vm._v(_vm._s(_vm.notificationMessage) + "\n          ")]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "110px",
      "background": "#26304d !important"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a54b5c7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a54b5c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HeaderComponent.vue
// module id = 518
// module chunks = 3